var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_89_2085)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6812 7.70557C16.6677 7.70557 16.6474 7.70557 16.6271 7.70557C13.05 7.34718 9.47967 7.21194 5.94312 7.57033L4.56367 7.70557C4.27966 7.73262 4.02947 7.52976 4.00242 7.24575C3.97537 6.96175 4.17823 6.71832 4.45547 6.69127L5.83492 6.55603C9.43233 6.19088 13.0771 6.33288 16.7285 6.69127C17.0058 6.71832 17.2086 6.96851 17.1816 7.24575C17.1613 7.50947 16.9382 7.70557 16.6812 7.70557Z",
    fill: "#00AEC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22933 7.02262C8.20228 7.02262 8.17524 7.02262 8.14143 7.01586C7.87095 6.96852 7.68161 6.7048 7.72894 6.43432L7.87771 5.5485C7.9859 4.89935 8.13466 4 9.71018 4H11.4818C13.0641 4 13.2129 4.93316 13.3143 5.55526L13.4631 6.43432C13.5104 6.71157 13.3211 6.97528 13.0506 7.01586C12.7734 7.06319 12.5097 6.87385 12.4691 6.60337L12.3203 5.72431C12.2257 5.13602 12.2054 5.02106 11.4886 5.02106H9.71695C9.0002 5.02106 8.98668 5.11573 8.88525 5.71755L8.72972 6.59661C8.68915 6.84681 8.47276 7.02262 8.22933 7.02262Z",
    fill: "#00AEC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7666 18.5384H8.42541C6.06547 18.5384 5.9708 17.2333 5.89641 16.1784L5.45688 9.36909C5.4366 9.09185 5.65298 8.84842 5.93023 8.82813C6.21423 8.81461 6.4509 9.02423 6.47119 9.30147L6.91072 16.1108C6.9851 17.1387 7.01215 17.5241 8.42541 17.5241H12.7666C14.1866 17.5241 14.2137 17.1387 14.2813 16.1108L14.7208 9.30147C14.7411 9.02423 14.9846 8.81461 15.2618 8.82813C15.539 8.84842 15.7554 9.08508 15.7351 9.36909L15.2956 16.1784C15.2212 17.2333 15.1266 18.5384 12.7666 18.5384Z",
    fill: "#00AEC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7181 14.8192H9.46639C9.18914 14.8192 8.95923 14.5893 8.95923 14.3121C8.95923 14.0348 9.18914 13.8049 9.46639 13.8049H11.7181C11.9954 13.8049 12.2253 14.0348 12.2253 14.3121C12.2253 14.5893 11.9954 14.8192 11.7181 14.8192Z",
    fill: "#00AEC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2861 12.1144H8.9051C8.62786 12.1144 8.39795 11.8845 8.39795 11.6073C8.39795 11.33 8.62786 11.1001 8.9051 11.1001H12.2861C12.5633 11.1001 12.7933 11.33 12.7933 11.6073C12.7933 11.8845 12.5633 12.1144 12.2861 12.1144Z",
    fill: "#00AEC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_89_2085",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_89_2085"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.682353 0 0 0 0 0.756863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_89_2085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_89_2085",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.39d295c901f9beaa052bd18862df1eb6.svg";
export { ForwardRef as ReactComponent };